module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar"
  }, [(_vm.estoySiendoReemplazado || _vm.estoyReemplazando) ? _c('div', {
    staticClass: "delegaciones-mostrar"
  }, [_c('delegaciones-mostrar-reemplazo')], 1) : _vm._e(), _c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": _vm.empresa_full
    }
  })])]), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Salir")])])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showLogOutModal) ? _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Cerrando sesión  "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73c4ecbf","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header_Logged.vue
// module id = 835
// module chunks = 0